import { Grid, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import { CancelButton, ConfirmButton } from "../../styles/buttonStyles";

export const DialogContainerGrid = styled(Grid)({
    padding: 20,
    textAlign: "center"
});

export const AmountLabel = styled(Typography)({
    fontWeight: "bold",
    fontSize: 26,
    margin: "10px 0 10px 0"
});

export const PaymentConfirmButton = styled(ConfirmButton)(({ theme }) => ({
    flexGrow: 1,
    height: 50,
    borderRadius: "0 5px 5px 0 !important",
}));

export const PaymentCancelButton = styled(CancelButton)(({ theme }) => ({
    flexGrow: 1,
    borderRadius: "5px 0 0 5px !important"
}));

export const ActionsContainerGrid = styled(Grid)({
    display: "flex",
    justifyContent: "space-around",
    width: "100%",
    flexWrap: "nowrap"
});